// extracted by css-extract-rspack-plugin
export default {"savedOptionsContainer":"oxbvWBYBaq4i7xyU","savedOptionsLabel":"ocJ90drbNgkFlS6w","savedOptionsTooltipIcon":"dYuPXEBgdAoxezyT","tooltipText":"GjEWQIXSK8p6eHA0"};